import { Link } from "react-router-dom";

// STERILTRON wordmark with hexagon engineering mark.
export const Logo = ({ light = false, className = "" }) => {
  const stroke = light ? "#ffffff" : "#6db500";
  const text = light ? "text-white" : "text-brand-900";
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <svg width="30" height="30" viewBox="0 0 64 64" fill="none" aria-hidden="true">
        <path d="M32 6l22.5 13v26L32 58 9.5 45V19z" stroke={stroke} strokeWidth="3.5" />
        <circle cx="32" cy="32" r="7" fill={stroke} />
      </svg>
      <span className={`font-heading font-extrabold text-xl tracking-tight ${text}`}>
        STERILTRON
      </span>
    </span>
  );
};
